<div class="modal-header">
    <h2 class="modal-title">{{ azione }} progetto</h2>
    <button class="close" type="button" aria-label="Chiudi" (click)="activeModal.close()" tabindex="0">
        <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
    </button>
</div>
<div class="modal-body">
    <form class="form" role="form" [formGroup]="criteriaForm">
        <ngb-accordion  aria-busy="true" #acc="ngbAccordion" activeIds="tab-1">
            <ngb-panel id="tab-1" title="Informazioni principali">
                <ng-template ngbPanelContent>
                    <ng-container formGroupName="pianoInterventoDTO">
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="idTipoIntervento">Tipo intervento*</label>
                                <select class="form-control" formControlName="idTipoIntervento" id="idTipoIntervento">
                                    <option [ngValue]="null">Seleziona un'opzione...</option>
                                    <option *ngFor="let item of datalist.tipologiaIntervento" [ngValue]="item.id">{{ item.descrizione }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="enteEsecutore">Ente esecutore</label>
                                <input class="form-control" id="enteEsecutore" formControlName="enteEsecutore" type="text">
                            </div>
                            <div class="form-group col-md-4">
                                <app-toolkit-datepicker
                                    id="dataPrevista"
                                    label="Data prevista"
                                    formControlName="dataPrevista"
                                    [disabled]="pianoInterventoDTO.controls['dataPrevista'].disabled">
                                </app-toolkit-datepicker>
                            </div>
                            <div class="form-group col-md-4">
                                <app-toolkit-datepicker
                                    id="dataEsecuzione"
                                    label="Data esecuzione"
                                    formControlName="dataEsecuzione"
                                    [disabled]="pianoInterventoDTO.controls['dataEsecuzione'].disabled">
                                </app-toolkit-datepicker>
                            </div>
                            <div class="form-group col-md-12">
                                <label for="descrizione">Descrizione</label>
                                <textarea class="form-control" id="descrizione" formControlName="descrizione"></textarea>
                            </div>
                            <div class="form-group col-md-12">
                                <label for="note">Note</label>
                                <textarea class="form-control" id="note" formControlName="note"></textarea>
                            </div>
                        </div>
                    </ng-container>
                </ng-template>
            </ngb-panel>
            <ngb-panel id="tab-2" title="Associa progetto*">
                <ng-template ngbPanelContent>
                    <p class="border-bottom mb-2 pb-2">È possibile selezionare il Progetto ricercandolo tramite l'apposito form, oppure inserendone uno nuovo attraverso il pulsante "Inserisci progetto".</p>
                    <ng-container *ngIf="pianoInterventoDTO.controls['idProgetto'].value">
                        <h6>Progetto selezionato</h6>
                        <p>Sigla: <strong>{{ currentProgetto.sigla }}</strong></p>
                        <p>CUP: <strong>{{ currentProgetto.cup }}</strong></p>
                        <p>Titolo progetto: <strong>{{ currentProgetto.denominazione }}</strong></p>
                        <button *ngIf="canEdit" type="button" class="btn btn-sm btn-outline-primary" (click)="resetFormRicercaProgetto()">Cambia progetto</button>
                    </ng-container>
                    <ng-container *ngIf="!pianoInterventoDTO.controls['idProgetto'].value" formGroupName="ricercaProgettoDTO">
                        <div class="border-bottom mb-2 pb-2">
                            <button type="button" class="btn btn-sm btn-primary" (click)="creaProgetto(modalCreaProgetto)">Inserisci progetto</button>
                        </div>
                        <div class="form-row pt-2">
                            <h6 class="col-12">Ricerca Progetto</h6>
                            <div class="form-group col-md-6">
                                <label for="denominazione">Titolo progetto</label>
                                <input class="form-control" id="denominazione" formControlName="denominazione" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="sigla">Sigla</label>
                                <input class="form-control" id="sigla" formControlName="sigla" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="cup">CUP</label>
                                <input class="form-control" id="cup" formControlName="cup" type="text">
                            </div>
                        </div>
                        <div class="button-actions">
                            <button type="button" class="btn btn-sm btn-outline-primary" (click)="resetFormRicercaProgetto()">Pulisci</button>
                            <button type="button" class="btn btn-sm btn-primary" (click)="submitFormRicercaProgetto(true)">Ricerca</button>
                        </div>
                        <h6 id="table_description" class="sr-only">Risultati ricerca</h6>
                        <div style="transform: rotateX(180deg);" class="table-responsive mb-3">
                            <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_description">
                                <thead class="thead-light">
                                    <tr>
                                        <th scope="col">ID</th>
                                        <th scope="col">Titolo progetto</th>
                                        <th scope="col">Sigla</th>
                                        <th scope="col">CUP</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of tableDataProgetto">
                                        <td>{{ item.idProgetto }}</td>
                                        <td>{{ item.denominazione }}</td>
                                        <td>{{ item.sigla }}</td>
                                        <td>{{ item.cup }}</td>
                                        <td class="actions">
                                            <button aria-label="seleziona progetto" class="btn btn-sm btn-outline-primary" (click)="selezionaProgetto(item)">Seleziona</button>
                                        </td>
                                    </tr>
                                    <tr *ngIf="!tableDataProgetto.length">
                                        <td colspan="6"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <ngb-pagination
                            *ngIf="tableDataProgetto.length"
                            [(page)]="paginatorProgetto.page"
                            [pageSize]="paginatorProgetto.size"
                            [collectionSize]="paginatorProgetto.total"
                            [maxSize]="5"
                            (pageChange)="onPageChangeProgetto($event)"></ngb-pagination>
                    </ng-container>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>
    </form>
    <p class="mt-3"><strong>* Campi obbligatori.</strong></p>
</div>
<div class="modal-footer">
    <button type="button" tabindex="0" (click)="activeModal.close()" class="btn btn-outline-primary">Chiudi</button>
    <button *ngIf="canEdit" type="button" tabindex="0" (click)="savePianoInterventi()" class="btn btn-primary">Salva</button>
</div>
<!--from here-->
<ng-template #modalCreaProgetto let-modalCreaProgetto>
    <div class="modal-header">
        <h4 class="modal-title">Inserisci nuovo progetto</h4>
        <button type="button" class="close" aria-label="Close" (click)="modalCreaProgetto.close()">
            <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
        </button>
    </div>
    <div class="modal-body">
        <form class="form" role="form" [formGroup]="criteriaForm">
            <ng-container formGroupName="inserisciProgettoDTO">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="cup">CUP*</label>
                        <input class="form-control" id="cup" formControlName="cup" type="text">
                    </div>
                </div>
                <div class="form-row">
                    <!-- <div class="form-group col-md-3">
                        <label for="codiceUnivoco">Codice univoco</label>
                        <input class="form-control" id="codiceUnivoco" formControlName="codiceUnivoco" type="text">
                    </div> -->
                    <div class="form-group col-md-12">
                        <label for="denominazione">Titolo progetto*</label>
                         <textarea class="form-control" id="denominazione" formControlName="denominazione" >
                         </textarea>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="descrizione">Descrizione</label>
                        <textarea class="form-control" id="descrizione" formControlName="descrizione"></textarea>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="sigla">Sigla</label>
                        <input class="form-control" id="sigla" formControlName="sigla" type="text">
                    </div>
                    <div class="form-group col-md-2">
                        <label for="importoEuro">Importo (€)</label>
                        <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '€ ', thousands: '.', decimal: ',' }" class="form-control" id="importoEuro" formControlName="importoEuro" type="text">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="amministrazioneAggiudicatrice">Amministrazione aggiudicatrice</label>
                        <input class="form-control" id="amministrazioneAggiudicatrice" formControlName="amministrazioneAggiudicatrice" type="text">
                    </div>
                    <div *ngIf="!disabledLabel" class="form-group col-md-3" >
                        <label for="studio">Studio</label>
                        <input class="form-control" id="studio" formControlName="studio" type="text">
                    </div>
                    <div *ngIf="!disabledLabel" class="form-group col-md-3">
                        <label for="impresa">Impresa</label>
                        <input class="form-control" id="impresa" formControlName="impresa" type="text">
                    </div>
                    <div class="form-group col-md-12">
                        <label for="vincoliPai">Vincoli PAI esistenti</label>
                        <textarea class="form-control" id="vincoliPai" formControlName="vincoliPai"></textarea>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="note">Annotazioni</label>
                        <textarea class="form-control" id="note" formControlName="note"></textarea>
                    </div>
                </div>
            </ng-container>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="modalCreaProgetto.close()">Chiudi</button>
        <button type="button" class="btn btn-outline-primary mr-2" (click)="recuperaDatiCup()">Conferma</button>
        <button type="button" class="btn btn-primary" (click)="creaProgetto_confirm()">Inserisci</button>
    </div>
</ng-template>